import { Box, Button, Center, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import MemberService from "../../../services/members/member-service";
import LogosNotification from "../../../utils/notification-utils";

interface ChangeMemberDetailProps {
    member: any,
    onClose: any
};


const ChangeMemberPassword: FC<ChangeMemberDetailProps> = ({ member, onClose }) => {
    const [formValue, setFormValue] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>([]);

    useEffect(() => {
        setFormValue({
            name: member.fullName,
            password: "",
            confirmPassword: ""
        });
        setIsLoading(false);
    }, []);

    const handleFormSubmit = (values: any) => {
        setErrors([]);
        setIsSubmiting(true);

        MemberService.ChangePassword(member.id, values.password, values.confirmPassword)
            .then((res: any) => {
                LogosNotification.Success("Password berhasil diperbaharui.");
                setTimeout(() => window.location.reload(), 2000);
            }).catch((error) => {
                if (typeof error.response.data.result.errors === "object") {
                    let errorMessages: any = [];
                    const ObjectKey = Object.keys(error.response.data.result.errors);
                    ObjectKey.map((item) => {
                        error.response.data.result.errors[item].map((message: any) => {
                            errorMessages.push(`${message}`);
                        })
                    });
                    setErrors(errorMessages);
                }
            }).finally(() => {
                setIsSubmiting(false);
            });
    };

    if (isLoading)
        return <></>;

    return (
        <Modal isOpen={true} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Change Password</ModalHeader>
                                <ModalBody pt={5}>
                                    <FormControl isInvalid={!!(errors.name && touched.name)} mt={4}>
                                        <FormLabel>Nama</FormLabel>
                                        <Field
                                            as={Input}
                                            id='name'
                                            placeholder='Nama'
                                            name={'name'}
                                            disabled={true}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nama wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.password && touched.password)} mt={4}>
                                        <FormLabel>Password Baru</FormLabel>
                                        <Field
                                            as={Input}
                                            type={"password"}
                                            id='password'
                                            placeholder='Password'
                                            name={'password'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Password Baru wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.password}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.confirmPassword && touched.confirmPassword)} mt={4}>
                                        <FormLabel>Ulangi Password Baru</FormLabel>
                                        <Field
                                            as={Input}
                                            type={"password"}
                                            id='confirmPassword'
                                            placeholder='Ulangi Password Baru'
                                            name={'confirmPassword'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Ulangi Password Baru wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
                                    </FormControl>
                                </ModalBody>

                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Ubah Password</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>

                {
                    <Box mt={4}>
                        {
                            errors.length > 0 && errors.map((error: any) => {
                                return (
                                    <Text color={'red'}>{error}</Text>
                                );
                            })
                        }
                    </Box>
                }
            </ModalContent>
        </Modal>
    );
};

export default ChangeMemberPassword;